define('components/word-control/models/word-control-wrapper',[
    "components/word-control/models/word-control"
], function(WordControlModel) {

    "use strict";

    var WordControlWrapperModel = Backbone.Model.extend({

        "defaults": function() {
            return {
                "currentRange": null //used in case of custom selection
            };
        },

        /**
         * Initializes the model with given options and calls function to initialize model of component.
         * @method initialize
         * @param options {Object} object to initialize attributes.
         */
        "initialize": function(options) {
            _(options).each(function(value, property) {
                this[property] = value;
            }, this);
            this.initWordControlModel();
        },

        /**
         * Initializes the word control model.
         * @method initWordControlModel
         */
        "initWordControlModel": function() {
            this.set('wordControlModel', new WordControlModel({
                "manager": this.get('manager'),
                "textToLoad": this.get('textToLoad'),
                "selectionType": this.get('selectionType'),
                "isAllBlocksSelectable": this.get('isAllBlocksSelectable'),
                "maxSelectionsAllowed": this.get('maxSelectionsAllowed')
            }));

            this._listenToWordControlEvents();
        },


        /**
         * Listens to the events triggered by word control model.
         * @method _listenToWordControlEvents
         */
        "_listenToWordControlEvents": function() {
            this.listenTo(this.get('wordControlModel'), "BLOCK_CLICKED", this.blockClicked);
        },

        "blockClicked": function(blockId) {
            this.modifySelectableBlocks(blockId);
        },

        "modifySelectableBlocks": function(blockId) {
            var previousRange = null,
                selectableBlockIndex = null,
                currentRange = this.get('currentRange'),
                invalidSelection = false,
                selectableBlocks = this.get('selectableBlocks'),
                numBlockId = blockId * 1,
                numStart,
                numEnd;
            selectableBlockIndex = $.inArray(blockId, selectableBlocks);
            if (this.selectionType !== 'custom') {
                if (selectableBlockIndex > -1) {
                    selectableBlocks.splice(selectableBlockIndex, 1); // removes selection (toggle)
                    this._updateSelectableBlocks(blockId, false);
                } else {
                    selectableBlocks.push(blockId);
                    this.set('selectableBlocks', selectableBlocks);
                    this._updateSelectableBlocks(blockId, true);
                }
            } else { //  selection type is custom, in this case, two clicks are required to make a selection.
                currentRange = this.get('currentRange');
                previousRange = $.extend(true, {}, currentRange);
                if (currentRange === null) {
                    if (isNaN(numBlockId)) {
                        this.trigger('customBlockClicked', blockId);
                        return;
                    }
                    currentRange = {};
                    currentRange.start = blockId;
                    currentRange.end = blockId;
                    this.set('currentRange', currentRange);
                } else {
                    if (isNaN(numBlockId)) {
                        this.trigger('showAlert');
                        return;
                    }

                    numStart = currentRange.start * 1;
                    numEnd = currentRange.end * 1;
                    if (numBlockId < numStart) {

                        currentRange.start = blockId;

                    } else if (numBlockId > numStart && numBlockId < numEnd) {
                        if (numBlockId - numStart < numEnd - numBlockId) {
                            currentRange.start = blockId;
                        } else {
                            currentRange.end = blockId;
                        }
                    } else {
                        currentRange.end = blockId;
                    }

                    _.each(this.get('selectableBlocks'), function(block) {
                        if (currentRange.start < block.start * 1 && currentRange.end > block.end * 1) {
                            invalidSelection = true;
                        }
                    });
                    if (invalidSelection) {
                        this.trigger("showAlert");
                        this.set('currentRange', previousRange);
                        invalidSelection = false;
                        return;
                    }
                }

                this._updateSelectableBlocks(currentRange, true);

            }
        },

        /**
         * Adds range of block in currentRange to SelectableBlocks for CUSTOM.
         * @method addCurrentRangeToSelectableBlocks
         */
        "addCurrentRangeToSelectableBlocks": function() {

            var currentRange = this.get('currentRange');

            if (currentRange && currentRange.start && currentRange.end) {
                this.get('selectableBlocks').push(currentRange);
                this._updateSelectableBlocks(currentRange, true);
                this.set('currentRange', null);
            }
        },

        /**
         * Resets the model.
         * @method reset
         */
        "reset": function() {
            this.set({
                "selectableBlocks": [],
                "currentRange": null,
                "textToLoad": '',
                "selectionType": 'word'
            });
            this.selectableBlocks = [];
            this._updateSelectableBlocks();

        },

        /**
         * Gets and returns selectableBlocks.
         * @method getCompiledJSON
         */
        "getCompiledJSON": function() {
            return this.get('selectableBlocks');
        },

        "parseJSON": function(selectableBlocks) {
            this.set('selectableBlocks', selectableBlocks);
        },

        /**
         * Triggers event that other view/model will listen.
         * @method _updateSelectableBlocks
         * @param blockId {String} data-selectableid of the block clicked.
         * @param isAdded {Boolean} tells whether the block is being added or removed.
         */
        "_updateSelectableBlocks": function(blockId, isAdded) {

            this.trigger('selectableBlocksChange', blockId, isAdded);
        },

        /**
         * Updates the model according to given data.
         * @method update
         * @param options {Object} contains the data to be updated.
         */
        "update": function(options) {
            _(options).each(function(value, property) {
                this[property] = value;
            }, this);
            options.selectableBlocks = []; //modifies options object to save reference manipulation ahead
            this.get('wordControlModel').updateModel(options);

        }
    });

    return WordControlWrapperModel;
});

